var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColorSwatch = function SvgColorSwatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.836,
    cy: 12.188,
    r: 12,
    fill: "inherit"
  })));
};
export default SvgColorSwatch;